import { render, staticRenderFns } from "./ChatVoucherCard.vue?vue&type=template&id=77e550c5&scoped=true&"
import script from "./ChatVoucherCard.vue?vue&type=script&lang=js&"
export * from "./ChatVoucherCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatVoucherCard.vue?vue&type=style&index=0&id=77e550c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e550c5",
  null
  
)

export default component.exports